// Guest.js
import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { auth } from '../firebase';
import { signInAnonymously, onAuthStateChanged } from "firebase/auth";
import { TextField } from '@mui/material';
import HomeLogo from './HomeLogo';

const Guest = () => {
    const [name, setName] = useState('');

    const handleNameChange = (e) => setName(e.target.value);
    const location = useLocation();
    const navigate = useNavigate();

    const searchParams = new URLSearchParams(location.search);
    const gameID = searchParams.get('game');

    const handleSubmit = () => {
        signInAnonymously(auth)
            .then(() => {
                window.localStorage.setItem('nameForSignIn', name);
                console.log("Name: " + name);
                // Wait for auth state to change
                const unsubscribe = onAuthStateChanged(auth, (user) => {
                    console.log("Here: " + window.localStorage.getItem('nameForSignIn'));
                    if (user) {
                        navigate(`/finishSignUp?game=${gameID}`);
                        unsubscribe(); // Unsubscribe once we receive the user
                    }
                });
            })
            .catch((error) => {
                console.error(error);
            });
    };

    return (
        <div className="sg-page">
            <HomeLogo />
            <div className="sg-center-col" style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', paddingBottom: '12vh' }}>
                <div className="sg-card sg-anim-fadeup" style={{ textAlign: 'center' }}>
                    <span className="sg-kicker">Quick start</span>
                    <h2 style={{ fontSize: '2rem', margin: '8px 0 6px' }}>
                        What should we call you?
                    </h2>
                    <p className="sg-muted" style={{ margin: '0 0 18px' }}>
                        Pick a name and we'll drop you right in.
                    </p>
                    <TextField
                        fullWidth
                        variant="outlined"
                        margin="normal"
                        label="Name"
                        value={name}
                        onChange={handleNameChange}
                        onKeyDown={(e) => { if (e.key === 'Enter') handleSubmit(); }}
                    />
                    <button
                        type="submit"
                        className="sg-btn sg-btn--primary sg-btn--block sg-btn--lg"
                        onClick={handleSubmit}
                        style={{ marginTop: 18 }}
                    >
                        Let's go →
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Guest;
